import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BtCommonModule } from '../common/bt-common.module';
import { InsightImageComponent } from './insight-image.component';
import { InsightImageGalleryComponent } from './insight-image-gallery/insight-image-gallery.component'
import { ViewportThumbSelectionComponent } from './viewport-thumb-selection/viewport-thumb-selection.component';
import { InsightImageDialogComponent } from '@ng-cloud/badger-core/viewport/insight-image-dialog/insight-image-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    BtCommonModule
  ],
  declarations: [
    InsightImageComponent,
    InsightImageDialogComponent,
    InsightImageGalleryComponent,
    ViewportThumbSelectionComponent
  ],
  exports: [
    InsightImageComponent,
    InsightImageGalleryComponent,
    ViewportThumbSelectionComponent
  ]
})

export class BtViewportModule {
}
